import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import styles from "./CKYCVerificationFailed.module.scss";

export default function CKYCVerificationFailed() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          navigate("/enter-aadhar");
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className={`${styles.wrapper} auto-height`}>
      {/* Header */}
      <div className={styles.header}>
        <h1>CKYC Verification</h1>

        <p>We will securely retrieve your CKYC record from CERSAI and auto-fill your details.</p>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.illustration}>
          <img src="/images/reject.png" alt="Verification Failed" />
        </div>

        <h2>We couldn't find your CKYC record.</h2>

        <p className={styles.description}>{state || "We couldn't find an existing CKYC record using the details provided."}</p>

        <p className={styles.description}>Don't worry - you can complete your KYC using another method.</p>
      </div>

      {/* Bottom Actions */}
      <div className={styles.actions}>
        <p>
          Redirecting to previous screen in {countdown} {countdown === 1 ? "second" : "seconds"}...
        </p>

        <div className={styles.security}>
          <span>🔒</span>
          <span>Your information is secure and encrypted</span>
        </div>
      </div>
    </div>
  );
}
